import md5 from "js-md5";

import React, { useEffect, useState, useRef } from "react";

import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";

import { BsDownload } from "react-icons/bs";
import { LuArrowRight } from "react-icons/lu";
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";

import { apiRequest } from "../api/apiRequest";

import { OpenFilter } from "../components/Biblioteca/OpenFilter";
import { NumberLawFilter } from "../components/Biblioteca/NumberLawFilter";
import Loading from "../components/Loading";
import Navbar from "../components/Navbar";
import SideMenu from "../components/SideMenu";

import { useBibliotecaContext } from "../context/BibliotecaContext";

function ReformaTributaria() {
    const { t } = useTranslation();

    const {
        filtroAberto,
        numeroDaLei
    } = useBibliotecaContext();

    const [loading, setLoading] = useState(false);
    const [loadingPdfKey, setLoadingPdfKey] = useState(null);
    const [error, setError] = useState(null);
    const [data, setData] = useState([]);
    const [page, setPage] = useState(0);
    const [produto, setProduto] = useState(null);
    const [expandedId, setExpandedId] = useState(null);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [hasMore, setHasMore] = useState(false);
    const [dateStart, setDateStart] = useState("");
    const [dateEnd, setDateEnd] = useState("");

    const debounceTimeoutRef = useRef(null);

    const fetchData = async () => {
        setLoading(true);
        setError(null);
        setHasMore(true);

        const params = {
            pagina: page,
            limite_quantidade: itemsPerPage
        };

        if (dateStart) {
            params.data_de = dateStart;
        }

        if (dateEnd) {
            params.data_ate = dateEnd;
        }

        if (filtroAberto.length > 0) {
            params.filtro_aberto = filtroAberto;
        }

        if (numeroDaLei.length > 0) {
            params.numero_da_lei = numeroDaLei;
        }

        try {
            const response = await apiRequest(
                "GET",
                `/dashboard/tax-reform`,
                "",
                params
            );

            setData(response.data.data);
            setProduto(response.data.produto_ativo);
            setHasMore(response.data.data.normas.length === itemsPerPage);
        } catch (error) {
            setError(error);
        }

        setLoading(false);
    };

    const handleClick = (id) => {
        setExpandedId(expandedId === id ? null : id);
    };

    const handleDebouncedChange = () => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchData();
        }, 1000);
    };

    const handleOpenProtectedPdf = async (pdfKey) => {
        if (loadingPdfKey) {
            return;
        }

        setLoadingPdfKey(pdfKey);

        try {
            const response = await apiRequest(
                "GET",
                `/protected-pdf/${pdfKey}`,
                null,
                null,
                'blob'
            );

            if (response.data.type === 'application/json') {
                const errorText = await response.data.text();

                console.error('Erro retornado pelo backend:', JSON.parse(errorText));

                return;
            }

            // cria um Blob com os dados recebidos e define o tipo
            const file = new Blob([response.data], { type: 'application/pdf' });
            // cria uma URL temporária para este Blob no navegador
            const fileURL = URL.createObjectURL(file);
            // abre essa URL local em uma nova aba
            window.open(fileURL, '_blank');
        } catch (error) {
            console.error('Erro ao baixar o PDF:', error);

            if (error.response && error.response.data && error.response.data.type === 'application/json') {

                try {
                    const errorText = await error.response.data.text();
                    const errorJson = JSON.parse(errorText);

                    console.error('Mensagem da API:', errorJson.message || errorJson.error);
                } catch (e) {
                    console.error('Falha ao ler o blob de erro da API.', e);
                }
            }
        } finally {
            setLoadingPdfKey(null);
        }
    };

    useEffect(() => {
        handleDebouncedChange();

        return () => clearTimeout(debounceTimeoutRef.current);
    }, [
        numeroDaLei,
        filtroAberto,
    ]);

    useEffect(() => {
        fetchData();
    }, [
        dateStart,
        dateEnd,
        itemsPerPage,
        page,
    ]);

    const startItem = page * itemsPerPage + 1;
    const endItem = startItem + (data?.normas?.length || 0) - 1;

    const formatDate = (dateString) => {
        const [datePart] = dateString.split(" ");
        const [year, month, day] = datePart.split("-");

        return `${day}/${month}/${year}`;
    };

    const getHash = (norma) => {
        const nomeArquivo = `documento_norma_${norma}.pdf`;

        return md5(nomeArquivo);
    };

    return (
        <div id="wrapper" style={{ backgroundColor: "#043A5E" }}>
            <SideMenu />

            <div id="page-wrapper" style={{ backgroundColor: "#FCFCFD" }}>
                <Navbar />

                <div
                    className="pl-3 custom-normal ml-2"
                    style={{ fontSize: "34px", fontWeight: "600" }}
                >
                    {t("taxReform.title")}
                </div>

                {produto === 'brasil' && (
                    <>
                        <div
                            className="pl-4 mt-2 mb-2 custom-normal"
                            style={{ fontSize: "16px", fontWeight: "600" }}
                        >
                        </div>

                        <div className="wrapper wrapper-content">
                            <div className="d-flex justify-content-between">
                                <div
                                    className="border-0 shadow-sm bg-white p-4"
                                    style={{ borderRadius: "1rem", width: "25%" }}
                                >
                                    {/* Filtros */}
                                    <div>
                                        <div
                                            className="mb-4 custom-normal"
                                            style={{ fontSize: "25px", fontWeight: "600" }}
                                        >
                                            {t("biblioteca.filters")}
                                        </div>

                                        <div>
                                            {/* Palavra-chave */}
                                            <OpenFilter />

                                            {/* Numero da lei */}
                                            <NumberLawFilter />

                                            {/* Data de publicação */}
                                            <div className="form">
                                                <label className="control-label mt-2">
                                                    {t("biblioteca.publicationDate")}
                                                </label>

                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: "10px",
                                                        marginTop: "2px",
                                                    }}
                                                >
                                                    {/* De */}
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "8px",
                                                        }}
                                                    >
                                                        <span style={{ width: "30px", textAlign: "left" }}>
                                                            {t("biblioteca.from")}:
                                                        </span>

                                                        <div style={{ position: "relative", flex: 1 }}>
                                                            <input
                                                                type="date"
                                                                value={dateStart}
                                                                onChange={(e) => setDateStart(e.target.value)}
                                                                style={{
                                                                    width: "100%",
                                                                    padding: "13px",
                                                                    paddingRight: "35px",
                                                                    border: "1px solid #E5E7EB",
                                                                    borderRadius: "7px",
                                                                    fontSize: "14px",
                                                                    color: "#6C737F",
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Até */}
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "8px",
                                                        }}
                                                    >
                                                        <span style={{ width: "30px", textAlign: "left" }}>
                                                            {t("biblioteca.to")}:
                                                        </span>

                                                        <div style={{ position: "relative", flex: 1 }}>
                                                            <input
                                                                type="date"
                                                                value={dateEnd}
                                                                onChange={(e) => setDateEnd(e.target.value)}
                                                                style={{
                                                                    width: "100%",
                                                                    padding: "13px",
                                                                    paddingRight: "35px",
                                                                    border: "1px solid #E5E7EB",
                                                                    borderRadius: "7px",
                                                                    fontSize: "14px",
                                                                    color: "#6C737F",
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="mt-4">
                                                <button
                                                    className="btn btn-primary w-100"
                                                    title={t('taxReform.taxReformTitle')}
                                                    onClick={() => window.open("https://reformaupdate.taxupdate.com.br", "_blank")}
                                                >
                                                    {t("taxReform.taxReform")}
                                                </button>
                                            </div>

                                            <div className="mt-3">
                                                <button
                                                    className="btn btn-primary w-100"
                                                    title={t('taxReform.taxReformTimeLineTitle')}
                                                    onClick={() => handleOpenProtectedPdf('tax-reform-timeline')}
                                                    disabled={loadingPdfKey !== null}
                                                >
                                                    {loadingPdfKey === 'tax-reform-timeline'
                                                        ? t("common.loading")
                                                        : t("taxReform.taxReformTimeline")
                                                    }
                                                </button>
                                            </div>

                                            <div className="mt-3">
                                                <button
                                                    className="btn btn-primary w-100"
                                                    title={t('taxReform.taxReformTimeLineTitle')}
                                                    onClick={() => handleOpenProtectedPdf('tax-reform-timeline-v1')}
                                                    disabled={loadingPdfKey !== null}
                                                >
                                                    {loadingPdfKey === 'tax-reform-timeline-v1'
                                                        ? t("common.loading")
                                                        : t("taxReform.taxReformTimelineV1")
                                                    }
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div style={{ width: "73%" }}>
                                    <div className="w-100">
                                        <div className="d-flex justify-content-between align-items-center mt-4 mb-4 w-100">
                                            <div
                                                className="pl-3 custom-normal"
                                                style={{ fontSize: "34px", fontWeight: "600" }}
                                            >
                                                {t("taxReform.subTitle")}
                                            </div>
                                        </div>

                                        <div className="bg-white" style={{ borderRadius: "1rem" }}>
                                            {loading && (
                                                <div style={{ textAlign: "center", padding: "20px" }}>
                                                    <Loading />
                                                </div>
                                            )}

                                            {error && (
                                                <div style={{ textAlign: "center", padding: "20px" }}>
                                                    Erro: {error.message}
                                                </div>
                                            )}

                                            {!loading && data.normas && data.normas.length === 0 && !error ? (
                                                <div style={{ textAlign: "center", padding: "20px" }}>
                                                    {t("biblioteca.noDataAvailable")}
                                                </div>
                                            ) : null}

                                            {!loading && !error && data.normas && data.normas.length > 0 ? (
                                                data.normas.map((norma) => (
                                                    <div
                                                        className="d-flex flex-column align-items-end"
                                                        key={norma.id}
                                                    >
                                                        <div className="d-flex justify-content-between align-items-center px-3 py-3 w-100">
                                                            <div style={{ width: "45%" }}>
                                                                <Link
                                                                    to={`/documento/norma/${norma.id}`}
                                                                    style={{ color: "#232730" }}
                                                                >
                                                                    <h3> {norma.nome}</h3>
                                                                </Link>

                                                                <div
                                                                    className="font-weight-light"
                                                                    onClick={() => handleClick(norma.id)}
                                                                    style={{
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                        display: "-webkit-box",
                                                                        WebkitBoxOrient: "vertical",
                                                                        WebkitLineClamp:
                                                                            expandedId === norma.id ? "unset" : 3,
                                                                        maxHeight:
                                                                            expandedId === norma.id ? "none" : "4.5em",
                                                                        cursor: "pointer",
                                                                        transition:
                                                                            "max-height 0.3s ease, padding-bottom 0.3s ease",
                                                                        paddingBottom:
                                                                            expandedId === norma.id ? "2rem" : "1rem",
                                                                    }}
                                                                >
                                                                    {norma.resumo}
                                                                </div>
                                                            </div>

                                                            <div className="font-weight-light">
                                                                {formatDate(norma.data_conteudo)}
                                                            </div>

                                                            <div
                                                                className="d-flex justify-content-between align-items-center"
                                                                style={{ fontSize: "22px" }}
                                                            >
                                                                <a
                                                                    className="mr-3"
                                                                    style={{ cursor: "pointer", color: "#232730" }}
                                                                    href={`http://www.taxupdate.co/norma/pdf/${norma.id
                                                                        }/${getHash(norma.id)}`}
                                                                    target="_blank"
                                                                >
                                                                    <BsDownload />
                                                                </a>

                                                                <div>
                                                                    <Link
                                                                        to={`/documento/norma/${norma.id}`}
                                                                        style={{ color: "#232730" }}
                                                                    >
                                                                        <LuArrowRight />
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div
                                                            className="border-bottom"
                                                            style={{ width: "97%" }}
                                                        ></div>
                                                    </div>
                                                ))
                                            ) : (
                                                <></>
                                            )}
                                        </div>

                                        {/* Paginação */}
                                        <div className="d-flex justify-content-end align-items-center py-2">
                                            <div className="mr-4">
                                                {" "}
                                                {t("biblioteca.documentsPerPage")}
                                            </div>

                                            <select
                                                className="mr-4"
                                                style={{ border: "none" }}
                                                value={itemsPerPage}
                                                onChange={(e) => {
                                                    setItemsPerPage(parseInt(e.target.value));
                                                    setPage(0);
                                                }}
                                            >
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                            </select>

                                            <div className="mr-4">
                                                {t("biblioteca.showing")} {startItem}-{endItem}
                                            </div>

                                            <div
                                                className="mr-4"
                                                style={{
                                                    fontSize: "20px",
                                                    cursor: page === 0 ? "default" : "pointer",
                                                    opacity: page === 0 ? 0.5 : 1,
                                                }}
                                                onClick={() => {
                                                    if (page > 0) {
                                                        setPage(page - 1);
                                                    }
                                                }}
                                            >
                                                <RiArrowLeftSLine />
                                            </div>

                                            <div
                                                className="mr-4"
                                                style={{
                                                    fontSize: "20px",
                                                    cursor: hasMore ? "pointer" : "default",
                                                    opacity: hasMore ? 1 : 0.5,
                                                }}
                                                onClick={() => {
                                                    if (hasMore) {
                                                        setPage(page + 1);
                                                    }
                                                }}
                                            >
                                                <RiArrowRightSLine />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {produto === 'latam' && (
                    <>
                        <div
                            className="pl-4 custom-normal ml-2 mt-2 mb-2"
                            style={{ fontSize: "24px", fontWeight: "600" }}
                        >
                            Argentina:
                        </div>
                        <a
                            className="pl-3 custom-normal ml-2"
                            style={{ fontSize: "20px", fontWeight: "600", color: "#007bff" }}
                            href="https://reformaupdate.taxupdate.com.br/download/reforma-tributaria-argentina.pdf"
                            target="_blank"
                        >
                            https://reformaupdate.taxupdate.com.br/download/reforma-tributaria-argentina.pdf
                        </a>
                    </>
                )}
            </div>
        </div>
    );
}

export default ReformaTributaria;
